import * as React from 'react';
import { QuoteLayout } from '../../quoteBlock/quoteBlock.layout';

export const NestedQuoteBlockLayout = (props: { text: string; author?: string; authorDescription?: string }) => {
  return (
    <section className="block-nested block-nested--quote">
      <div className="block__inner">
        <div className="block__content">
          <div className="block__text">
            <QuoteLayout {...props} />
          </div>
        </div>
      </div>
    </section>
  )
}
